(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/core/assets/javascripts/events/delete-tooltip-event.js') >= 0) return;  svs.modules.push('/components/onboarding/core/assets/javascripts/events/delete-tooltip-event.js');
"use strict";

const VerifyType = svs.components.tbUtils.verify.constants.VerifyType;
const verifyObject = svs.components.tbUtils.verify.verifyObject;
const BaseTooltipEvent = svs.components.onboarding.core.events.BaseTooltipEvent;
const TooltipEventType = svs.components.onboarding.core.events.constants.TooltipEventType;
class DeleteTooltipEvent extends BaseTooltipEvent {
  constructor(props) {
    verifyObject(props).schema({
      target: VerifyType.NotEmptyString
    });
    super(TooltipEventType.Delete, props);
  }
}

setGlobal('svs.components.onboarding.core.events.DeleteTooltipEvent', DeleteTooltipEvent);

 })(window);